(function () {
  const banners = new Set();
  let intervalId = null;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function setUnit(banner, unit, value) {
    const element = banner.querySelector(`[data-kronk-fight-club-unit="${unit}"]`);
    if (element) element.textContent = value;
  }

  function setLaunched(banner) {
    banner.classList.add('kronk-fight-club-home-banner--launched');

    const label = banner.querySelector('[data-kronk-fight-club-label]');
    if (label && banner.dataset.liveLabel) label.textContent = banner.dataset.liveLabel;

    const cta = banner.querySelector('[data-kronk-fight-club-cta]');
    if (cta) {
      cta.removeAttribute('aria-hidden');
      cta.removeAttribute('tabindex');
    }
  }

  function updateBanner(banner) {
    const target = Date.parse(banner.dataset.launchAt || '');
    if (!Number.isFinite(target)) return;

    const remaining = Math.max(0, target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setUnit(banner, 'days', String(days));
    setUnit(banner, 'hours', pad(hours));
    setUnit(banner, 'minutes', pad(minutes));
    setUnit(banner, 'seconds', pad(seconds));

    if (remaining === 0) setLaunched(banner);
  }

  function init() {
    document.querySelectorAll('[data-kronk-fight-club-banner]').forEach((banner) => {
      banners.add(banner);
      updateBanner(banner);
    });

    if (!banners.size || intervalId) return;

    intervalId = window.setInterval(() => {
      banners.forEach(updateBanner);
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState !== 'loading') init();
})();
